import script from "./PromotionCode.vue?vue&type=script&setup=true&lang=js"
export * from "./PromotionCode.vue?vue&type=script&setup=true&lang=js"

import "./PromotionCode.vue?vue&type=style&index=0&id=5eaad630&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eaad630"]])

export default __exports__